"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAllBrokersDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const constants_1 = require("../../../../../../services/service-lib/src/lib/constants");
const class_validator_1 = require("class-validator");
class GetAllBrokersDto {
    constructor() {
        this.page = constants_1.DEFAULT_VALUES.PAGE;
        this.limit = constants_1.DEFAULT_VALUES.LIMIT;
        this.sort = constants_1.DEFAULT_VALUES.SORT_BY;
    }
}
exports.GetAllBrokersDto = GetAllBrokersDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Page number for pagination",
        example: 1,
        required: false,
    }),
    tslib_1.__metadata("design:type", Number)
], GetAllBrokersDto.prototype, "page", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Number of records per page(by default limit is 10 records)",
        example: 10,
        required: false,
    }),
    tslib_1.__metadata("design:type", Number)
], GetAllBrokersDto.prototype, "limit", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Field to sort by",
        example: "id",
        required: false,
    }),
    tslib_1.__metadata("design:type", String)
], GetAllBrokersDto.prototype, "sort", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Search term for filtering",
        example: "Test",
        required: false,
    }),
    tslib_1.__metadata("design:type", String)
], GetAllBrokersDto.prototype, "search", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Field to search by (e.g., brokerName).",
        example: "test",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetAllBrokersDto.prototype, "searchBy", void 0);
